import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Beneficios from './components/Beneficios';
import Bonos from './components/Bonos';
import Precio from './components/Precio';
import ComoAcceder from './components/ComoAcceder';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] font-sans">
      <Navbar />
      <main>
        <Hero />
        <Beneficios />
        <Bonos />
        <Precio />
        <ComoAcceder />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
